import React from "react";

export default function Hero() {
  return (
    <header className="border-b border-border px-6 py-24 md:py-40">
      <div className="mx-auto grid max-w-screen-xl grid-cols-1 gap-12 md:grid-cols-12">
        <div className="animate-fade-in md:col-span-8">
          <h1 className="mb-8 text-balance text-5xl font-bold leading-[0.95] tracking-tight md:text-7xl">
            Strengthening India&rsquo;s Titanium{" "}
            <span className="text-accent">Dioxide</span> Market.
          </h1>
          <p className="max-w-xl text-lg leading-relaxed text-muted-foreground">
            Precision manufacturing of high-grade TiO2 pigments at our Thoothukudi
            facility. An industrial ecosystem driven by technical excellence and
            vertical integration.
          </p>
        </div>
        <div className="animate-fade-in flex flex-col justify-end gap-6 [animation-delay:200ms] md:col-span-4">
          <div className="border-t border-border pt-4">
            <span className="mb-2 block font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
              Capacity
            </span>
            <div className="flex items-baseline gap-2">
              <span className="text-4xl font-bold">15,000</span>
              <span className="text-sm text-muted-foreground">TPA</span>
            </div>
          </div>
          <div className="border-t border-border pt-4">
            <span className="mb-2 block font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
              Power Gen
            </span>
            <div className="flex items-baseline gap-2">
              <span className="text-4xl font-bold">2.0</span>
              <span className="text-sm text-muted-foreground">MW</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
